;(function($, window, undefined) {
    var timeout,
        $form    = $('form#find-product'),
        $results = $form.find('.search-results');

    var destroyResults = function() {
        $results.stop().fadeOut(function() {
            $(this).html('');
        });
    };

    $('body').click(function(e) {
        var $target = $(e.target);

        if (
            !$target.parents('form#find-product .search-results').length
            && $target[0] !== $results[0]
        ) {
            destroyResults();
        }
    });

    $form.find('input[name="search"]').keyup(function() {
        clearTimeout(timeout);

        var $ele = $(this);

        timeout = setTimeout(function() {
            var search = $ele.val();

            if (search.length >= 3) {
                $.ajax({
                    url:      window.ajaxurl,
                    method:   'GET',
                    dataType: 'html',
                    data:     {
                        action: 'product_finder_data_lookup',
                        search: search,
                        nonce:  $form.find('input[name="nonce"]').val()
                    }
                }).then(function(response) {
                    if (response.length) {
                        $results.html(response).stop().fadeIn();
                    }
                });
            } else {
                destroyResults();
            }
        }, 300);
    });
})(jQuery, window);
